import { Card, Progress } from 'antd';
import { useNavigate } from 'react-router-dom';
import { CardSkeleton } from './CardSkeleton';
import { SHARED_CARD_STYLES } from '../constants';
import { SharedCardHeader } from './SharedCardHeader';

type LegendItem = {
  color: string;
  label: string;
};

type ApplicationsCardProps = {
  title: string;
  tooltipText: string;
  totalApplications: number;
  percent?: number;
  legendItems?: LegendItem[];
  showViewButton?: boolean;
  onViewClick?: () => void;
  linkTo?: string;
  disabled?: boolean;
  showComingSoon?: boolean;
};

export const ApplicationsCard = ({
  title,
  tooltipText,
  totalApplications,
  percent,
  legendItems,
  showViewButton = true,
  onViewClick,
  linkTo,
  disabled = false,
  showComingSoon = true,
}: ApplicationsCardProps) => {
  const navigate = useNavigate();

  const handleViewClick = () => {
    if (onViewClick) {
      onViewClick();
    } else if (linkTo) {
      navigate(linkTo);
    }
  };

  const shouldShowViewButton = Boolean(
    showViewButton && (onViewClick || linkTo) && !disabled,
  );

  return (
    <Card
      className={SHARED_CARD_STYLES.className}
      headStyle={SHARED_CARD_STYLES.headStyle}
      bodyStyle={SHARED_CARD_STYLES.bodyStyle}
      title={
        <SharedCardHeader
          title={title}
          tooltipText={tooltipText}
          disabled={disabled}
          shouldShowViewButton={shouldShowViewButton}
          onViewClick={handleViewClick}
          showComingSoon={showComingSoon}
        />
      }
      bordered={false}
    >
      {disabled ? (
        <CardSkeleton />
      ) : (
        <div className="flex flex-col h-full justify-center">
          <div className="flex flex-row items-baseline mb-[16px]">
            <span className="text-4xl font-bold leading-none">
              {totalApplications}
            </span>
            <span className="text-base font-normal leading-none ml-2 align-bottom">
              Applications
            </span>
          </div>
          <div className={`flex flex-col justify-center gap-[26px]`}>
            <Progress
              percent={percent}
              strokeWidth={16}
              showInfo={false}
              strokeColor="#2D5BFF"
              trailColor="#E6EFFF"
              style={{ margin: '0px' }}
            />
            <div className="flex text-sm flex-wrap">
              {legendItems?.map((item, index) => (
                <div
                  key={index}
                  className={`flex items-center ${index > 0 ? 'ml-4' : 'mr-4'}`}
                >
                  <div
                    className="w-4 h-4 rounded-full mr-2"
                    style={{ backgroundColor: item.color }}
                  ></div>
                  <span style={{ lineHeight: 1 }}>{item.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </Card>
  );
};
